const moduleRoutes = [
  {
    path: '/matmed',
    component: () => import('@/views/Home'),
    children: [
      {
        path: 'exceptions/:tableId/:type/:id',
        component: () => import('./layouts/LayoutMatMedExceptions')
      }
    ]
  }
]

export default router => {
  moduleRoutes.forEach(route => {
    router.addRoute(route)
  })
}
